import React, { useState } from 'react'
import List from './List'
import Add from './Add';
import DetailsMain from './Details/Main'
export default function Main({admin}) {
    const [activeTab, setActiveTab] = useState("list");
    const [infoData,setInfoData] =useState({})

    const handleTab = (type,data) => {
        setActiveTab(type)
        setInfoData(data)
    }
    return (
        <>
            <div className="container-fluid">
                {activeTab == "list" ?
                    <List handleTab={handleTab} />
                    : ""}
                {activeTab == "add" ?
                    <Add handleTab={handleTab} admin={admin}/>
                    : ""}
                {activeTab == "view" ?
                    <DetailsMain handleTab={handleTab}  infoData={infoData}/>
                    : ""}
            </div>
        </>
    )
}
